var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 355,
    viewBox: "0 0 400 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.507 377.052C134.631 391.924 165.897 399.872 197.709 400.236C229.521 400.601 260.961 393.371 289.418 379.147C317.876 364.923 342.529 344.116 361.332 318.453C380.134 292.79 392.544 263.011 397.529 231.59C402.515 200.169 399.932 168.012 389.997 137.79C380.061 107.567 363.059 80.1501 340.402 57.8163C317.745 35.4825 290.087 18.8759 259.725 9.37539C229.363 -0.125077 197.172 -2.24527 165.826 3.19087L167.95 15.4428C197.348 10.3446 227.537 12.333 256.012 21.2428C284.486 30.1526 310.425 45.7267 331.673 66.6719C352.921 87.6172 368.866 113.329 378.184 141.673C387.502 170.017 389.923 200.174 385.248 229.642C380.572 259.109 368.935 287.036 351.301 311.104C333.668 335.171 310.547 354.685 283.859 368.024C257.171 381.364 227.686 388.144 197.851 387.802C168.017 387.461 138.695 380.007 112.32 366.059L106.507 377.052Z",
    fill: "url(#paint0_linear_5833_17458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9599 50.2941C34.0512 78.2591 12.277 115.459 3.86532 156.379C-4.54637 197.299 0.852265 239.76 19.2609 277.468L30.4981 272.301C13.2341 236.937 8.17109 197.116 16.0598 158.74C23.9485 120.364 44.3689 85.4773 74.2937 59.251L65.9599 50.2941Z",
    fill: "url(#paint1_linear_5833_17458)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5833_17458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.585 43.7571C111.961 55.5182 82.1463 78.3046 61.7076 108.627C41.2689 138.948 31.3329 175.134 33.4214 211.642C35.5098 248.149 49.5076 282.966 73.2708 310.759C97.0341 338.552 129.253 357.79 164.992 365.526C200.732 373.262 238.022 369.069 271.151 353.59C304.281 338.111 331.423 312.199 348.422 279.823C365.42 247.447 371.337 210.392 365.267 174.332C359.196 138.272 341.473 105.196 314.811 80.1697L247.331 152.06C258.271 162.329 265.544 175.902 268.035 190.7C270.526 205.497 268.098 220.703 261.123 233.989C254.148 247.275 243.009 257.908 229.414 264.26C215.819 270.612 200.517 272.333 185.851 269.158C171.185 265.984 157.964 258.089 148.212 246.684C138.461 235.279 132.717 220.992 131.86 206.01C131.003 191.029 135.08 176.18 143.467 163.737C151.854 151.294 164.089 141.944 178.297 137.117L146.585 43.7571Z",
    fill: "url(#paint2_linear_5833_17458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5833_17458",
    x1: 27.7533,
    y1: 73.3773,
    x2: 200,
    y2: 400.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEECE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5833_17458",
    x1: 27.7533,
    y1: 71.2225,
    x2: 192.072,
    y2: 392.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEECE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5833_17458",
    x1: 56.3529,
    y1: 96.0139,
    x2: 200.368,
    y2: 369.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEECE9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5833_17458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 334.438,
    height: 334.438,
    fill: "white",
    transform: "translate(33.1484 34.8721)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/CIRCLE.d7b68ee215342780ddb2f79cc4854423.svg";
export { ForwardRef as ReactComponent };